/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Information fulfilled for an institute
 * @export
 * @interface InstituteInformation
 */
export interface InstituteInformation {
    /**
     * Message displayed at the top of the institute's page
     * @type {string}
     * @memberof InstituteInformation
     */
    generalMessage?: string;
}

/**
 * Check if a given object implements the InstituteInformation interface.
 */
export function instanceOfInstituteInformation(value: object): value is InstituteInformation {
    return true;
}

export function InstituteInformationFromJSON(json: any): InstituteInformation {
    return InstituteInformationFromJSONTyped(json, false);
}

export function InstituteInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstituteInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'generalMessage': json['generalMessage'] == null ? undefined : json['generalMessage'],
    };
}

export function InstituteInformationToJSON(json: any): InstituteInformation {
    return InstituteInformationToJSONTyped(json, false);
}

export function InstituteInformationToJSONTyped(value?: InstituteInformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generalMessage': value['generalMessage'],
    };
}

